// Redux Actions
import {
  SET_MESSAGE_IFRAME,
  SET_FULLWIDTH_IFRAME,
  SET_STATE_VIDEO_IFRAME,
  SET_MINIMIZE_PLAYLIST_IFRAME,
  SET_TREE_VIDEOS_IFRAME,
  SET_VIDEO_IFRAME,
  SET_MODE_IFRAME,
  SET_SAMPLER,
} from "../types";

export function setMessageIframe(payload) {
  return { type: SET_MESSAGE_IFRAME, payload }
}

export function setFullWidthIframe(payload) {
  return { type: SET_FULLWIDTH_IFRAME, payload }
}

export function setStateVideoIframe(payload) {
  return { type: SET_STATE_VIDEO_IFRAME, payload }
}

export function setMinimizePlaylistIframe(payload) {
  return { type: SET_MINIMIZE_PLAYLIST_IFRAME, payload }
}

export function setTreeVideosIframe(payload) {
  return { type: SET_TREE_VIDEOS_IFRAME, payload }
}

export function setVideoIframe(payload) {
  return { type: SET_VIDEO_IFRAME, payload }
}

export function setModeIframe(payload) {
  return { type: SET_MODE_IFRAME, payload }
}

export function setSampler(payload) {
  return { type: SET_SAMPLER, payload }
}
